module.exports = __webpack_public_path__ + "static/media/img2-1.79520f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/soilcheck/rhumedad/img2-1.png
// module id = 2369
// module chunks = 3